import React, { useState } from 'react';
import PackageInnerItem from './PackageInnerItem';
import { useFormik } from 'formik';
import { PACKING_MOCK_DATA } from '../mocks';
import {
  fetchGetPackingOrder,
  fetchGetPackingSticker,
  fetchPutPackingOrder,
} from '../../../../actions/orders';
import { useDispatch } from 'react-redux';
import Button from '../../../common/Button';
import { saveBase64AsPdf } from '../../../../helpers';
import { toast } from 'react-toastify';
import { hideModal } from '../../../../actions/modal';

const PackageItem = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { measurements, items, barcode, num, index, id } = props;

  const dispatch = useDispatch();

  const handleChangeInput = (id, value) => {
    setFieldValue(id, value);
  };

  const handleSticker = (barcode) => {
    dispatch(fetchGetPackingSticker(barcode))
      .then((res) => {
        saveBase64AsPdf({ ...res, fileName: `sticker-${barcode}.pdf` });
        toast.info('Стикер успешно создан');
      })
      .catch((error) => {
        error.data.errors.forEach((e) => {
          toast.error(e.message);
        });
      });
  };

  const formik = useFormik({
    initialValues: {
      editedPackings: {
        orders: [
          {
            id: id,
            packings: [
              {
                barcode: barcode,
                num: num,
                items: items,
              },
            ],
          },
        ],
      },
    },
    enableReinitialize: true,

    onSubmit: (values) => {
      dispatch(fetchPutPackingOrder(values.editedPackings));
    },
  });

  const { values, handleSubmit, setFieldValue, errors } = formik;

  return (
    <form>
      <div className="packing-main">
        <div className="packing-top">
          <div style={{ marginRight: '10px' }}>
            <div style={{ fontWeight: '500' }}>{`${
              typeof num !== 'undefined' ? '#' + num : '# '
            }${barcode}`}</div>
            {measurements ? (
              <div style={{ marginLeft: '10px' }} className="parameters">
                <span>{`ШхВхГ: ${measurements.dimensions.width / 10} x ${
                  measurements.dimensions.height / 10
                } x ${measurements.dimensions.depth / 10} cм`}</span>
                <span style={{ marginLeft: '8px' }}>{`Вес: ${measurements.weight} г`}</span>
              </div>
            ) : null}
          </div>
          <div className="d-flex">
            <div className="show-packing-info-button" onClick={() => handleSticker(barcode)}>
              <div>Напечатать стикер</div>
              <i className="fe-copy" />
            </div>
          </div>
          <div className="d-flex">
            <div className="show-packing-info-button" onClick={() => setIsEdit(!isEdit)}>
              <div>Редактировать место</div>
              <i className="fe-edit-2" />
            </div>
          </div>
          <div className="d-flex">
            <div className="show-packing-info-button" onClick={() => setIsOpen(!isOpen)}>
              <div>Позиции</div>
              <i className={!isOpen ? 'fe-eye' : 'fe-eye-off'} />
            </div>
          </div>
        </div>

        {(isOpen && items?.length) || (isEdit && items.length) ? (
          <div className="packing-items">
            {items.map((item, i) => (
              <PackageInnerItem
                key={`${item.productId}-${item.variantId}-${i}`}
                {...props}
                item={item}
                i={i}
                isEdit={isEdit}
                values={values}
                handleChangeInput={handleChangeInput}
              />
            ))}
          </div>
        ) : null}
        {isEdit && (
          <div className="row">
            <div className="col-3 offset-10">
              <Button
                text="Сохранить изменения"
                style={{ marginTop: '16px' }}
                onClick={handleSubmit}
              />
            </div>
          </div>
        )}
      </div>
    </form>
  );
};

export default PackageItem;
